import LLTrendingNow from '@/locales/TrendingNow/en';
import LLEdito from '@/locales/Edito/en';
import LLTravel from '@/locales/Travel/en';
import LLFuture from '@/locales/Future/en';
import LLArty_Paris from '@/locales/Arty_Paris/en';
import LLArty_Digital from '@/locales/Arty_Digital/en';
import LLKeyReport from '@/locales/KeyReport/en';
import LLPioneer_MartinRoland from '@/locales/Pioneer_MartinRoland/en';
import LLPioneer_Chassard from '@/locales/Pioneer_Chassard/en';
import LLBack from '@/locales/Back/en';
import LLProfiting from '@/locales/Profiting/en';
import LLLegal from '@/locales/Legal/en';

export const  en = {

    // les éléments du menu
    // pour l'edito, vu qu'il est variable en fonction du marché (present dans l'url), la structure est un peu différente
    menu: {
        EditoCH: {
            segment: 'editorial',
            title: 'Editorial',
        },
        EditoFR: {
            segment: 'editorial',
            title: 'Editorial',
        },
        EditoLU: {
            segment: 'editorial',
            title: 'Editorial',
        },
        EditoMC: {
            segment: 'editorial',
            title: 'Editorial',
        },
        EditoUK: {
            segment: 'editorial',
            title: 'Editorial',
        },
        Essential: {
            segment: 'essentials',
            title: 'Essentials',
        },
        TrendingNow: {
            segment: 'trends-notebook',
            title: 'Trends notebook',
        },
        Travel: {
            segment: 'kent-very-english-vintage',
            title: 'Kent: a very English vintage',
        },
        Future: {
            segment: 'reinventing-materials-building-tomorrow',
            title: 'Reinventing materials, building tomorrow',
        },
        Arty_Paris: {
            segment: 'paris-contemporary-art-artistic-feast-comes-home',
            title: 'Paris and Contemporary Art, an artistic feast comes home.',
        },
        Arty_Digital: {
            segment: 'what-digital-art',
            title: 'What is digital art?',
        },
        KeyReport: {
            segment: 'forests-age-climate-change',
            title: 'Forests in the age of climate change',
        },
        Pioneer_MartinRoland: {
            segment: 'philanthropy-art-taming-time',
            title: 'Philanthropy or the art of taming time',
        },
        Pioneer_Chassard: {
            segment: 'maelle-chassard-storyteller-extraordinaire',
            title: 'Maëlle Chassard, storyteller “extraordinaire”',
        },
        Back: {
            segment: 'twelve-years-memories-rebirth-polaroid',
            title: '12 years of memories, the rebirth of the Polaroid',
        },
        Profiting: {
            segment: 'committed-responsible-beauty',
            title: 'Committed to responsible beauty',
        },
        Legal: {
            segment: 'credits-legal-information',
            title: 'Credits & legal information',
        },

    },

    // les différentes pages, on scinde en fichiers, sinon ca va être trop long et chiant a contribuer

    EditoCH: LLEdito,
    EditoFR: LLEdito,
    EditoLU: LLEdito,
    EditoMC: LLEdito,
    EditoUK: LLEdito,

    TrendingNow: LLTrendingNow,

    Travel: LLTravel,

    Future: LLFuture,

    Arty_Paris: LLArty_Paris,

    Arty_Digital: LLArty_Digital,

    KeyReport: LLKeyReport,

    Pioneer_MartinRoland: LLPioneer_MartinRoland,

    Pioneer_Chassard: LLPioneer_Chassard,

    Back: LLBack,

    Profiting: LLProfiting,

    Legal: LLLegal,

    home: {
        logoBaseLine: 'Towards a more engaged world <br />with Societe&nbsp;Generale Private&nbsp;Banking',
        logoBaseLineKH: 'Towards a more engaged world <br />with SG&nbsp;Kleinwort&nbsp;Hambros',
        logoDate: 'Winter 2023 #9',
        title: 'Forests in the age of climate change',
        artitle1title: `Reinventing materials, <br/>building tomorrow`,
        artitle2title: `Maëlle Chassard, <br/>storyteller "extraordinaire"`,
        artitle3title: `What is digital art?`,
    },

    next: 'Next: ',

    welcome_message : 'EN - Welcome to Your Vue.js App',
    popular_links : 'EN - Popular Links',
    ecosystem : 'EN - Ecosystem',
    test: {
        toto: 'toto label',
        tutu: 'tutu label',
        titi: {
            test: 'titi label',
        },
    },
    counterUpSeparator: ',',
    counterUpDecimal: '.',
};
